/**
 * Filter & Sort panel.
 *
 * Nothing is applied while the customer is choosing — Apply builds the URL from
 * whatever is ticked and navigates. Every input carries the exact Shopify filter
 * param name rendered by Liquid, so no param names are hard-coded here.
 */
(function () {
  'use strict';

  var panel = null;

  function open() {
    if (!panel) return;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fpanel-open');
  }

  function close() {
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fpanel-open');
  }

  function money(value) {
    return '$' + String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ------------------------------------------------------------ price slider */

  function priceEls() {
    var section = panel.querySelector('[data-fpanel-price]');
    if (!section) return null;
    return {
      section: section,
      low: section.querySelector('[data-price-low]'),
      high: section.querySelector('[data-price-high]'),
      fill: section.querySelector('[data-price-fill]'),
      display: section.querySelector('[data-price-display]'),
      lowLabel: section.querySelector('[data-price-low-label]'),
      highLabel: section.querySelector('[data-price-high-label]'),
      ceiling: parseInt(section.getAttribute('data-ceiling'), 10) || 0
    };
  }

  function paintPrice() {
    var p = priceEls();
    if (!p || !p.low || !p.high) return;

    var lo = parseInt(p.low.value, 10);
    var hi = parseInt(p.high.value, 10);

    /* Handles must not cross over each other. */
    if (lo > hi) {
      if (document.activeElement === p.low) {
        lo = hi;
        p.low.value = lo;
      } else {
        hi = lo;
        p.high.value = hi;
      }
    }

    if (p.display) p.display.textContent = money(lo) + ' - ' + money(hi);
    if (p.lowLabel) p.lowLabel.textContent = money(lo);
    if (p.highLabel) p.highLabel.textContent = money(hi);

    if (p.fill && p.ceiling > 0) {
      p.fill.style.left = ((lo / p.ceiling) * 100) + '%';
      p.fill.style.right = (100 - (hi / p.ceiling) * 100) + '%';
    }
  }

  /* ------------------------------------------------------------------ apply */

  function apply() {
    var params = new URLSearchParams();

    var sort = panel.querySelector('input[name="sort_by"]:checked');
    if (sort && sort.value) params.set('sort_by', sort.value);

    panel.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) {
      if (input.name) params.append(input.name, input.value);
    });

    var p = priceEls();
    if (p && p.low && p.high) {
      var lo = parseInt(p.low.value, 10);
      var hi = parseInt(p.high.value, 10);
      var minParam = p.section.getAttribute('data-min-param');
      var maxParam = p.section.getAttribute('data-max-param');
      /* Only send bounds that actually narrow the range. */
      if (minParam && lo > 0) params.set(minParam, lo);
      if (maxParam && hi < p.ceiling) params.set(maxParam, hi);
    }

    var query = params.toString();
    window.location.href = window.location.pathname + (query ? '?' + query : '');
  }

  function clear() {
    panel.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.checked = false;
    });
    panel.querySelectorAll('input[name="sort_by"]').forEach(function (input) {
      input.checked = false;
    });

    var p = priceEls();
    if (p && p.low && p.high) {
      p.low.value = 0;
      p.high.value = p.ceiling;
      paintPrice();
    }
  }

  /* ----------------------------------------------------------------- events */

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || typeof t.closest !== 'function') return;

    if (t.closest('[data-fpanel-open]')) {
      evt.preventDefault();
      open();
      return;
    }

    if (!panel) return;

    if (t.closest('[data-fpanel-close]')) {
      evt.preventDefault();
      close();
      return;
    }

    var toggle = t.closest('.fpanel__toggle');
    if (toggle && panel.contains(toggle)) {
      evt.preventDefault();
      var group = toggle.closest('.fpanel__group');
      var content = group ? group.querySelector('.fpanel__content') : null;
      if (!content) return;
      var willOpen = content.hasAttribute('hidden');
      if (willOpen) {
        content.removeAttribute('hidden');
      } else {
        content.setAttribute('hidden', '');
      }
      group.classList.toggle('fpanel__group--open', willOpen);
      toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    if (t.closest('[data-fpanel-apply]')) {
      evt.preventDefault();
      apply();
      return;
    }

    if (t.closest('[data-fpanel-clear]')) {
      evt.preventDefault();
      clear();
    }
  });

  document.addEventListener('input', function (evt) {
    if (!panel || !panel.contains(evt.target)) return;
    if (evt.target.matches('[data-price-low], [data-price-high]')) paintPrice();
  });

  document.addEventListener('keydown', function (evt) {
    if (evt.key === 'Escape' || evt.key === 'Esc') close();
  });

  function init() {
    panel = document.getElementById('FilterPanel');
    if (!panel) return;
    paintPrice();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
